import { motion } from "framer-motion";
import { FaSalesforce, FaReact, FaNodeJs, FaAws, FaPython } from "react-icons/fa";
import { SiMulesoft, SiTensorflow } from "react-icons/si";
import { IoLogoTableau } from "react-icons/io5";

const portfolioData = [
  {
    id: "sales-service-cloud",
    title: "Global Service Cloud Transformation",
    desc: "A comprehensive Salesforce Service Cloud implementation for a Fortune 500 enterprise. We unified their customer support channels, deployed Einstein Chatbots for automated ticketing, and developed custom Lightning Web Components (LWC) to drastically reduce case resolution time.",
    image: require("../assets/images/portfolio-crm.png"),
    icons: [FaSalesforce, SiMulesoft, FaAws],
    imageLeft: true
  },
  {
    id: "einstein-analytics",
    title: "AI & Tableau CRM Integration",
    desc: "We engineered an intelligent dashboarding solution combining Salesforce Sales Cloud with Tableau CRM (Einstein Analytics). By leveraging advanced predictive models, the regional sales teams gained real-time pipeline forecasting and automated lead scoring, increasing win rates by 23%.",
    image: require("../assets/images/portfolio-ai.png"),
    icons: [FaSalesforce, IoLogoTableau, FaPython, SiTensorflow],
    imageLeft: false
  },
  {
    id: "mulesoft-erp",
    title: "MuleSoft ERP Sync Pipeline",
    desc: "Architected a scalable API network using MuleSoft Anypoint Platform to seamlessly synchronize legacy on-premise ERP data directly into Salesforce core objects. This automated complex order-to-cash workflows and ensured 100% data consistency.",
    image: require("../assets/images/portfolio-integration.png"),
    icons: [SiMulesoft, FaNodeJs, FaReact],
    imageLeft: true
  },
  {
    id: "fsc-wealth",
    title: "Wealth Management Digital Hub",
    desc: "Implemented Salesforce Financial Services Cloud (FSC) to provide a 360-degree view of client assets for a global wealth management firm. We integrated external portfolio management systems and deployed a secure client portal via Experience Cloud.",
    image: require("../assets/images/portfolio-finance.png"),
    icons: [FaSalesforce, SiMulesoft, FaReact],
    imageLeft: false
  },
  {
    id: "cpq-industrial",
    title: "CPQ & Billing Optimization",
    desc: "Transformed the quote-to-cash process for an industrial equipment manufacturer using Salesforce CPQ. We eliminated manual pricing errors by implementing multi-dimensional quoting logic and automated transactional billing, reducing cycle time by 40%.",
    image: require("../assets/images/portfolio-cpq.png"),
    icons: [FaSalesforce, FaNodeJs, FaAws],
    imageLeft: true
  },
  {
    id: "b2b-commerce",
    title: "B2B Commerce Transformation",
    desc: "Developed a robust B2B e-commerce platform on Salesforce Commerce Cloud, enabling distributors to place bulk orders, track shipments in real-time, and manage custom contract pricing. The solution handles over 100k daily transactions.",
    image: "https://images.unsplash.com/photo-1472851294608-062f824d29cc?q=80&w=2670&auto=format&fit=crop",
    icons: [FaSalesforce, SiMulesoft, FaPython],
    imageLeft: false
  }
];

function PortfolioGrid() {
  return (
    <section className="portfolio-section">
      <div className="portfolio-header">
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          Our Portfolio | <span className="hero-accent">Salesforce Projects & Case Studies</span>
        </motion.h1>
      </div>

      <div className="portfolio-grid-container">
        {portfolioData.map((project, index) => (
          <motion.div
            className={`portfolio-card ${project.imageLeft ? 'image-left' : 'image-right'}`}
            key={project.id}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true, margin: "-100px" }}
          >
            <div className="portfolio-image-col">
              <div className="portfolio-image-wrapper">
                <img src={project.image} alt={project.title} />
              </div>
            </div>

            <div className="portfolio-text-col">
              <h2>{project.title}</h2>
              <p>{project.desc}</p>

              <div className="portfolio-tech-stack">
                {project.icons.map((Icon, idx) => (
                  <div className="tech-icon-circle" key={idx}>
                    <Icon size={20} />
                  </div>
                ))}
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}

export default PortfolioGrid;
